import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ListErrorsComponent } from './list-errors.component';
import { ShowHideInput } from './show-hide-input';
import { ShowAuthedDirective } from './show-authed.directive';
import { ScrollToBottomDirective } from './scroll-to-bottom.directive';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    ListErrorsComponent,
    ShowHideInput,
    ShowAuthedDirective,
    ScrollToBottomDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ListErrorsComponent,
    ShowHideInput,
    RouterModule,
    ShowAuthedDirective
  ]
})
export class SharedModule { }
